import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/RfqAuditReport/Filter'

export default createListViewComponent({
  entityName: entityNames.rfqAuditReport,
  filterTemplateType: 'RFQAuditReport',
  initialFilterDto: (self) => ({
    dateRange: { dateRangeType: 'MonthToDate' },
    auditReportType: 'RFQ',
  }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
  getSettingsType: (self) => 'rfq',
})(Filter)
